import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, unref as _unref, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/logo.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-30c147d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-bar" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo",
    src: _imports_0
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "CxCS OJ")
], -1))

import { routes } from "../router/routes";
import { useRouter } from "vue-router";
import { computed, ref } from "vue";
import { useStore } from "vuex";
import checkAccess from "@/access/checkAccess";
import ACCESS_ENUMS from "@/access/accessEnum";
import { Question, UserControllerService } from "../../generated";
import message from "@arco-design/web-vue/es/message"; // 导入路由


export default /*#__PURE__*/_defineComponent({
  __name: 'GlobalHeader',
  setup(__props) {

const router = useRouter(); // 该组件作为路由的跳转
const store = useStore();
// const loginUser; // 获取用户信息

// 菜单栏显隐的 路由过滤 用于vuefor循环判断
// 使用 computed 函数 当用户权限变更时(如登录) 动态更新菜单
const visibleRoutes = computed(() => {
  return routes.filter((item, index) => {
    if (item.meta?.hideInMenu) {
      return false; // filter过滤 隐藏菜单
    }

    // todo 判断用户有无权限(使用checkAccess 检验方法)
    if (!checkAccess(store.state.user.loginUser, item.meta?.access as string)) {
      // access权限强转为string
      return false;
    }

    return true; // 放行
  });
});

const selectedKeys = ref(["/"]); // 当前选中菜单项，默认主页
// 当路由跳转后，更新选中的菜单项
router.afterEach((to, form, failure) => {
  selectedKeys.value = [to.path]; // 更新为要跳转到的路径
});

const doMenuClick = (key: string) => {
  // 菜单点击响应 路径跳转
  router.push({
    path: key, // 菜单跳转路径
  });
};

// 测试修改用户信息 (模拟自动登录) 每次刷新三秒后更新
setTimeout(() => {
  // 调用user.ts中action定义的getloginUser方法 传入参数更新
  store.dispatch("user/getLoginUser", {
    // userName: "管理员：CxCS",
    // userRole: ACCESS_ENUMS.ADMIN,
  });
}, 3000);

/**
 *  跳转登录页面
 */
const tologin = () => {
  // 路由跳转 get传id
  router.push({
    path: `/user/login`,
  });
};

/**
 *  跳转注册页面
 */
const toregister = () => {
  // 路由跳转 get传id
  router.push({
    path: `/user/register`,
  });
};

/**
 *  用户注销
 */
const tologout = () => {
  const res = UserControllerService.userLogoutUsingPost();
  // 刷新页面
  window.location.reload();
};

console.log(store.state.user.loginUser);

return (_ctx: any,_cache: any) => {
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createBlock(_component_a_row, {
    id: "globalHeader",
    class: "grid-demo",
    align: "center",
    wrap: false
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, { flex: "auto" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_menu, {
            mode: "horizontal",
            "selected-keys": selectedKeys.value,
            onMenuItemClick: doMenuClick
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_menu_item, {
                key: "0",
                style: { padding: 0, marginRight: '38px' },
                disabled: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleRoutes.value, (item) => {
                return (_openBlock(), _createBlock(_component_a_menu_item, {
                  key: item.path
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item.name), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["selected-keys"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_col, { flex: "100px" }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            (_unref(store).state.user?.loginUser?.userName === '未登录')
              ? (_openBlock(), _createBlock(_component_a_space, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      status: "success",
                      onClick: tologin
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("登录")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_button, {
                      type: "primary",
                      status: "success",
                      onClick: toregister
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("注册")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_a_space, { key: 1 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, { type: "outline" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(store).state.user?.loginUser?.userName), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_button, {
                      type: "text",
                      style: {"color":"black"},
                      onClick: tologout
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("退出登录")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})